import React from 'react';
import PropTypes from 'prop-types';
import { useMedia } from 'react-use';

const Timer = ({ days, hours, minutes, seconds }) => {
  const isMobile = useMedia('(max-width: 767px)');
  const space = isMobile ? null : ' ';
  return (
    <>
      <span className="drop-digit">{days}{space}</span><span className="drop-unit">{isMobile ? 'd' : 'Days'} </span>
      <span className="drop-digit">{hours}{space}</span><span className="drop-unit">{isMobile ? 'h' : 'Hours'} </span>
      <span className="drop-digit">{minutes}{space}</span><span className="drop-unit">{isMobile ? 'm' : 'Mins'} </span>
      <span className="drop-digit">{seconds}{space}</span><span className="drop-unit">{isMobile ? 's' : 'Secs'} </span>
    </>
  );
};

Timer.propTypes = {
  days: PropTypes.string.isRequired,
  hours: PropTypes.string.isRequired,
  minutes: PropTypes.string.isRequired,
  seconds: PropTypes.string.isRequired
};

export { Timer };
